export const isDateInRange = (dateString, filterType, customStart, customEnd) => {
  if (!dateString || filterType === 'all') return true;
  
  const targetDate = new Date(dateString);
  targetDate.setHours(0, 0, 0, 0);
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const getStartOfWeek = (d) => {
    const date = new Date(d);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
  };

  if (filterType === 'today') {
    return targetDate.getTime() === today.getTime();
  }
  if (filterType === 'yesterday') {
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return targetDate.getTime() === yesterday.getTime();
  }
  if (filterType === 'this_week') {
    const startOfWeek = getStartOfWeek(today);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    return targetDate >= startOfWeek && targetDate <= endOfWeek;
  }
  if (filterType === 'last_week') {
    const startOfThisWeek = getStartOfWeek(today);
    const startOfLastWeek = new Date(startOfThisWeek);
    startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);
    const endOfLastWeek = new Date(startOfThisWeek);
    endOfLastWeek.setDate(endOfLastWeek.getDate() - 1);
    return targetDate >= startOfLastWeek && targetDate <= endOfLastWeek;
  }
  if (filterType === 'this_month') {
    return targetDate.getMonth() === today.getMonth() && targetDate.getFullYear() === today.getFullYear();
  }
  if (filterType === 'last_month') {
    let lastMonth = today.getMonth() - 1;
    let year = today.getFullYear();
    if (lastMonth < 0) {
      lastMonth = 11;
      year--;
    }
    return targetDate.getMonth() === lastMonth && targetDate.getFullYear() === year;
  }
  if (filterType === 'this_year') {
    return targetDate.getFullYear() === today.getFullYear();
  }
  if (filterType === 'last_year') {
    return targetDate.getFullYear() === today.getFullYear() - 1;
  }
  if (filterType === 'custom') {
    const start = customStart ? new Date(customStart) : null;
    const end = customEnd ? new Date(customEnd) : null;
    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);
    
    if (start && end) return targetDate >= start && targetDate <= end;
    if (start) return targetDate >= start;
    if (end) return targetDate <= end;
    return true;
  }
  
  return true;
};

export const formatAppDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = String(hours).padStart(2, '0');
  
  return `${day}/${month}/${year} ${strHours}:${minutes} ${ampm}`;
};

export const formatAppDateOnly = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  
  return `${day}/${month}/${year}`;
};
